const messages = {
  'USERNAME-INPUT-ERROR-TEXT': "Enter a valid user login to continue",
  'USERNAME-INPUT-LABEL-TEXT': "Enter user login",
  'USERNAME-INPUT-PLACEHOLDER-TEXT': "Enter username or email...",
  'USERNAME-NEXT-BUTTON-TEXT': 'Next',
  'LOGINFRAME-CHANGE-PASSWORD-TEXT': 'Change password for ',
  'LOGINFRAME-LOGIN-TEXT': 'Log in to ',
  'LOGINFRAME-ALL-RIGHTS-RESERVED': '  All rights reserved.',
  'LOGINFRAME-TERMS-POLICY-TEXT': 'By Signing in to this app, you agree to the LOGINFRAME-TERMS-TEXT and acknowledge the LOGINFRAME-POLICY-TEXT',
  'LOGINFRAME-TERMS-TEXT': 'Terms of Use',
  'LOGINFRAME-POLICY-TEXT': 'Privacy Policy',
  'LOGINFRAME-GET-HELP-TEXT': 'Get help',
  'LOGIN-USER-INPUT-ERROR-TEXT': "Enter a valid user login to continue",
  'LOGIN-USER-INPUT-LABEL-TEXT': "Enter user login",
  'LOGIN-USER-INPUT-PLACEHOLDER-TEXT': "Enter username or email...",
  'LOGIN-PASSWORD-INPUT-ERROR-TEXT': "Enter your password to continue",
  'LOGIN-PASSWORD-INPUT-LABEL-TEXT': "Enter password",
  'LOGIN-PASSWORD-INPUT-PLACEHOLDER-TEXT': "Enter your password...",
  'LOGIN-SIGN-IN': 'SIGN IN',
  'LOGIN-ERROR-TITLE': "Login Error",
  'ENTITYLIST-NO-NAME-EMAIL': "No name or email",
  'CONTACTS-STATUS-AVAILABLE': 'Available',
  'CONTACTS-STATUS-ACTIVE': 'Active',
  'CONTACTS-STATUS-ONLINE': 'Online',
  'CONTACTS-STATUS-OFFLINE': 'Offline',
  'CONTACTS-STATUS-BUSY': 'Busy',
  'CONTACTS-STATUS-UNKNOWN': 'Unknown',
  'HEADER-CONTACTS-ARIA-LABEL': "contact list",
  'ZEROSTATE-IMPORT-BTN-LABEL': "Import",
  'ZEROSTATE-ADD-CONTACT-BTN-LABEL': "Add Contact",
  'ENTITYLIST-NO-CONTACTS-DESCRIPTION': "Enter the number to send or import your contact list in settings.",
  'ENTITYLIST-NO-CONTACTS-FOUND': 'No contacts available. Import from your platform of choice by clicking import. Or add a new contact.',
  'ENTITYLIST-RETRIEVING': "Busy retrieving contacts.",
  'ARIA-EVENT-LIST-ADD-NEW-GROUP': 'New Contact',
  'NUMBER-SELECTION-MODAL-SELECT-NUMBER-TO-CALL': 'Select the number to call',
  'ENTITYLIST-SEARCHBAR-SEARCH-CONTACTS': "Search contacts",
  'NUMBER-SELECTION-MODAL-PREFERRED': 'Preferred',
  'ARIA-DIALING-INPUT-FIELD': "Dialing input field",
  'DIALING-INPUT-PLACEHOLDER-TEXT': "Enter number...",
  'FORGOT-INPUT-ERROR-TEXT': "Enter a valid email to continue",
  'FORGOT-INPUT-LABEL-TEXT': "Enter your email address to reset your account's password.",
  'FORGOT-INPUT-PLACEHOLDER-TEXT': "Enter your email...",
  'FORGOT-RESET-PASSWORD-BUTTON-TEXT': 'RESET PASSWORD',
  'FORGOT-CANCEL-BUTTON-TEXT': 'CANCEL',
  'CHANGE-PASSWORD-PASSWORD-LABEL': "Enter a new password for your account.",
  'CHANGE-PASSWORD-PASSWORD-PLACEHOLDER': "Enter your password...",
  'RESET-PASSWORD-NEW-PASSWORD-ERROR-TEXT': "Password does not meet requirements",
  'CHANGE-PASSWORD-CONFIRM-PASSWORD-PLACEHOLDER': "Confirm your password...",
  'RESET-PASSWORD-CONFIRM-PASSWORD-ERROR-TEXT': "Passwords do not match",
  'RESET-PASSWORD-CHANGE-PASSWORD': 'Change Password',
  'RESET-PASSWORD-CANCEL': 'Cancel',
  'CALLCONTROLS-MUTE-BTN-LABEL': "Mute",
  'CALLCONTROLS-HOLD-BTN-LABEL': "Hold",
  'CALLCONTROLS-AUDIO-BTN-LABEL': "Audio",
  'CALLCONTROLS-KEYPAD-BTN-LABEL': "Keypad",
  'CALLCONTROLS-TRANSFER-BTN-LABEL': "Transfer",
  'CALLCONTROLS-NEWCALL-BTN-LABEL': "New Call",
  'CALLCONTROLS-MERGE-BTN-LABEL': "Merge",
  'CALLCONTROLS-HANGUP-BTN-LABEL': "Hang Up",
  'CALLLIST-STATUS-ACTIVE': 'Active',
  'CALLLIST-STATUS-DIALING': 'Dialing',
  'CALLLIST-NOCALL': 'No Active call',
  'CALL-LIST-HEADER-TEXT': 'Transfer call',
  'ARIA-BACKSPACE-BTN': 'Backspace button',
  'CONTACT-DETAILS-FORM-SAVE-BTN-LABEL': 'Save',
  'CONTACT-DETAILS-FORM-CANCEL-BTN-LABEL': 'Cancel',
  'CALLHISTORY-TODAY': 'Today',
  'CALLHISTORY-YESTERDAY': 'Yesterday',
  'CALLHISTORY-NO-HISTORY-MSG': 'No history items to display',
  'CALLHISTORY-RETRIEVING-HISTORY-MSG': 'Busy Retrieving call history.',
  'CALLHISTORY-HEADER': 'History',
  'CALLHISTORY-CLEAR-HISTORY-BTN-LABEL': 'Clear',
  'SETTINGS-DEVICES-BTN-LABEL': "Devices",
  'SETTINGS-DEVICES-BTN-DESCRIPTION': "Change how your devices are configured.",
  'UPDATE-HEADER': 'Update Available',
  'UPDATE-MSG': 'Would you like to restart the application now?',
  'UPDATE-POSTPONE-BUTTON': 'Postpone (1 Min)',
  'UPDATE-UPDATE-BUTTON': 'Update',
  'ARIA-CANCEL-BTN': "Cancel button",
  'HEADER-BACK-ARIA-LABEL': "Back",
  'CALLDETAILS-MUTED': 'Muted',
  'CALLDETAILS-HOLD': 'On Hold',
  'CHANGE-EXTENSION-ERROR': "Cannot change extensions since you have an active call",
  'CHANGE-EXTENSION-ERROR-HEADING': "Error Changing Extension",
  'SOFTPHONE-DTMF-COMMANDS': "Enter number",
  'CALL-STATUS-ONHOLD': "On hold",
  'CALL-STATUS-ACTIVE': 'Active',
  'CALL-STATUS-DIALING': 'Dialing',
  'SETTINGS-NOTIFICATIONS-RINGTONE-TITLE': "Ring tone",
  'SETTINGS-NOTIFICATIONS-RINGTONE-DESCRIPTION': 'Change the ring tone used for incoming calls.',
  'SETTINGS-NOTIFICATIONS-RINGBACK-DESCRIPTION': 'Change the ring back tone used for outgoing calls.',
  'SETTINGS-NOTIFICATIONS-RINGBACK-TITLE': "Ring back",
  'SETTINGS-NOTIFICATIONS-DESCRIPTION': "When disabled you will not receive system notifications",
  'CANCEL-BTN-LABEL': 'Cancel',
  'SETTINGS-NOTIFICATIONS-BTN-DESCRIPTION': "Adjust how you receive updates.",
  'SETTINGS-APPEARANCE-BTN-DESCRIPTION': "Change the look and feel of the application.",
  'SETTINGS-CONTACTS-BTN-DESCRIPTION': "Import your contacts.",
  'SETTINGS-TROUBLESHOOTING-BTN-DESCRIPTION': "Tools to help you find out what's wrong",
  'SETTINGS-NOTIFICATIONS-BTN-LABEL': "Notifications",
  'SETTINGS-APPEARANCE-BTN-LABEL': "Appearance",
  'SETTINGS-CONTACTS-BTN-LABEL': "Contacts",
  'SETTINGS-TROUBLESHOOTING-BTN-LABEL': "Troubleshooting",
  'SETTINGS-CONTACTS-CSV-DOWNLOAD-ERROR-TITLE': "CSV Download Error",
  'SETTINGS-CONTACTS-CSV-DOWNLOAD-ERROR-BODY': 'Download Error',
  'CONTACTS-ALERT-HEADING-PHONE-NUMBER-INVALID': "Contact Phone Number Is Not Valid",
  'CONTACTS-ALERT-BODY-PHONE-NUMBER-INVALID': "The contact phone number you tried to call is not valid. Please edit contact to correct error. (No punctuation, no spaces)",
  'MISCONFIG-NO-EXTENSIONS': "No extensions found.",
  'MISCONFIG-SUPPORT': "Please contact your support organization.",
  'INCOMINGCALL-HEADER': 'Incoming Call',
  'INCOMINGCALL-DECLINE': 'Decline',
  'INCOMINGCALL-ACCEPT': 'Accept',
  'INCOMINGCALL-VOICEMAIL': 'Send to Voicemail',
  "ACTIVECALL-STATUS-RINGING": "Ringing",
  'CONTACT-FORM-INPUT-LAST-NAME-ERROR': "Last name required to create contact.",
  'CONTACT-FORM-ERROR-BODY': "There is invalid data in this form.",
  'CONTACT-FORM-ERROR-TITLE': "Form Validation Error",
  'INTERNET-CONNECTION-OFFLINE-ALERT-HEADING': "Offline -- No internet",
  'INTERNET-CONNECTION-OFFLINE-ALERT-BODY': "Please check your internet connection.",
  'WEBSOCKET-LOST-CONNECTION-ALERT-HEADING': "Lost connection to server",
  'WEBSOCKET-RECOVERED-CONNECTION-ALERT-HEADING': "Connection to server recovered",
  'WEBSOCKET-PERFORMING-CONNECTION-ALERT-HEADING': "We are having issues performing this action. Please, try again in a few moments.",
  'BLIND-BTN-LABEL': "Blind",
  'ATTENDED-BTN-LABEL': "Attended",
  'CALL-SERVICE-MAX-CALLS-EXCEEDED': "Maximum simultaneous call limit exceeded.  You must hang up a call to make a new call.",
  'CALL-SERVICE-GENERAL-ERROR': "Call service reported error",
  'CALL-SERVICE-RETRY-CONTACT-TECH-SUPPORT': "Please try again.  If error persists contact technical support.",
  'CALL-SERVICE-ERROR-FORBIDDEN': "Forbidden",
  'CALL-SERVICE-ERROR-BAD-REQUEST': "Bad Request",
  'CALL-SERVICE-ERROR-UNAUTHORIZED': "Unauthorized",
  'CALL-SERVICE-INVALID-VOLUME': "Invalid volume value received.",
  'CALL-SERVICE-NOT-REGISTERED': "Call service reporting not registered. Please check your network connection or restart the application and try again.",
  'CALL-SERVICE-GENERAL-ERROR-HEADING': "Call Service Error",
  'LOST-NETWORK-CONNECTION': 'Lost network connection. Check connection status.',
  'LOST-SERVER-CONNECTION': 'Lost server connection. Attempting to reconnect',
  'MAKE-CALL-MAX-CALLS-EXCEEDED': "Maximum simultaneous call limit exceeded.",
  "HEADER-SETTINGS-TITLE" : "Settings",
  "SETTINGS-ALWAYS-ON-TOP" : "Always on top",
  "SETTINGS-ALWAYS-ON-TOP-DESCRIPTION" : "When enabled the application will always display above your other applications.",
  "SETTINGS-ADVANCED-LOGGING" : "Advanced Logging",
  "SETTINGS-ADVANCED-LOGGING-DESCRIPTION" : "When enabled the application will create advanced logs to help with the diagnosing of application errors.",
  "SETTINGS-ADVANCED-LOGGING-ENABLE" : "Enable advanced logging",
  "SETTINGS-ADVANCED-LOGGING-VIEW-ALERTS-TITLE" : "View Alerts",
  "SETTINGS-ADVANCED-LOGGING-VIEW-ALERTS-DESCRIPTION" : "Access a record of alerts and logs",
  "SETTINGS-ADVANCED-LOGGING-SEND-SUPPORT-BUTTON" : "Send",
  'SETTINGS-IMPORT-CONTACTS' : 'Import your contacts',
  "SETTINGS-IMPORT-CONTACTS-DESCRIPTION" : "Select your option below to import contacts.",
  'SETTINGS-SAMPLE-CSV': 'Sample CSV',
  "SETTINGS-SAMPLE-CSV-DESCRIPTION" : "Pressing the button below will download a sample CSV file.",
  "SETTINGS-DOWNLOAD-SAMPLE-BUTTON" : "Download Sample",
  "SETTINGS-BACKUP" : "Backup",
  "SETTINGS-BACKUP-DESCRIPTION" : "Pressing the button below will download a CSV backup of your contacts. This is recommended before imports.",
  "SETTINGS-DOWNLOAD-BACKUP-BUTTON" : "Download Backup",
  'SETTINGS-INPUT-DEVICE' : "Input Device",
  'SETTINGS-INPUT-DEVICE-DESCRIPTION' : 'Set the input audio device you want to use.',
  'SETTINGS-OUTPUT-DEVICE' : "Output Device",
  'SETTINGS-OUTPUT-DEVICE-DESCRIPTION': 'Set the output audio device you want to use.',
  'CHANGE-PWD-ERROR-HEADING': "Change Password Error",
  'CHANGE-PWD-MISSING-TOKEN': "Missing token for change password.  Please retry 'Forgot password'.",
  'CHANGE-PWD-DOES-NOT-MEET-CRITERIA': "Password should contain at least one letter, at least one number, no white space, not start with @, and 8 or more characters.",
  'CHANGE-PWD-GENERAL-ERROR': "Error changing password.Please try again.  If error persists, contact Technical Suport",
  'FORGOT-PWD-EMAIL': "Email address not found; please contact system administrator",
  'FORGOT-ERROR-TITLE': "Reset Password Error",
  'FORGOT-PWD-SENT': "Reset email sent; Please check your email for next steps",
  'CONTACT-DETAILS-FORM-SELECT-LABEL': 'Label',
  'CONTACT-DETAILS-FORM-NUMBER-LABEL': 'Number',

};
module.exports = messages;
